import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { injectIntl, FormattedMessage } from 'react-intl';
import {
    Grid,
    Card,
    CardContent,
    Typography,
    LinearProgress,
    Table,
    Button,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
} from '@material-ui/core';
import CancelPresentation from '@material-ui/icons/CancelPresentation';

import { getValueFromLocalizedObject } from 'Console/utils/languageUtils';

const styles = (theme) => ({
    root: {
        padding: 0,
    },
    container: {
        display: 'flex',
        flexWrap: 'wrap',
        [theme.breakpoints.down('sm')]: {
            'flex-direction': 'column',
        },
    },
    item: {
        [theme.breakpoints.down('sm')]: {
            'padding-top': 5,
        },
    },
    tableTitles: {
        color: '#000',
        textAlign: 'left',
    },
    tableCell: {
        textAlign: 'left',
        borderBottom: 'none',
        paddingTop: theme.typography.pxToRem(16),
        cursor: 'pointer',
    },
    noJourneys: {
        width: '100%',
        height: 300,
        backgroundColor: 'white',
        marginTop: 20,
    },
});

const JourneyList = ({ classes, list, onRowClick, contentLanguage, deleteJourney }) => {
    if (list.length === 0) {
        return (
            <Grid container justify="center" alignItems="center" className={classes.noJourneys}>
                <Typography variant="body1">
                    <FormattedMessage
                        id="Journeys.list.empty"
                        defaultMessage="Go ahead and create your first journey"
                    />
                </Typography>
            </Grid>
        );
    }

    if (list.length > 0) {
        return (
            <div>
                <CardContent className={classes.root}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell className={classes.tableTitles} align="right">
                                    <Typography variant="subtitle1">
                                    <FormattedMessage id="General.name" defaultMessage="Name" /></Typography>
                                </TableCell>
                                <TableCell className={classes.tableTitles} align="right">                                    <Typography variant="subtitle1">

                                    <FormattedMessage id="General.actions" defaultMessage="Actions" /></Typography>
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {list.map((journey) => (
                                <TableRow key={journey.content.id}>
                                    <TableCell
                                        className={classes.tableCell}
                                        align="right"
                                        onClick={onRowClick(journey)}
                                    >
                                        {getValueFromLocalizedObject(
                                            journey.content.name,
                                            contentLanguage.code
                                        )}
                                    </TableCell>
                                    <TableCell
                                        className={classes.tableCell}
                                        align="right"
                                        style={{ width: '1.25rem' }}
                                    >
                                        <Button
                                            id="yeself-delete-button"
                                            size="small"
                                            onClick={deleteJourney(journey.content.id)}
                                        >
                                            <CancelPresentation />
                                        </Button>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </CardContent>
            </div>
        );
    }

    return (
        <Card>
            <CardContent>
                <Grid container justify="center" alignContent="center">
                    <Grid container alignContent="flex-start">
                        <Grid item xs={12}>
                            <LinearProgress className="yeself-linear-loading" />
                        </Grid>
                        <Grid item xs={12}>
                            <LinearProgress className="yeself-linear-loading" />
                        </Grid>
                        <Grid item xs={6}>
                            <LinearProgress className="yeself-linear-loading" />
                        </Grid>
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    );
};

export default withStyles(styles)(injectIntl(JourneyList));
